export const IMAGE_ALT_TEXT_MAX_LENGTH = 100;

export const IMAGE_ALT_TEXT_DEFAULT_PLACEHOLDER = 'Describe the image';

export const IMAGE_ALT_TEXT_HELP_TITLE = 'Image Alt Text';
export const IMAGE_ALT_TEXT_HELP_DESCRIPTION =
  'The alt text is used to describe the image to people who are unable to see it. It is also used by search engines to understand the content of the image.';
